import {Component, Input, TemplateRef} from '@angular/core';
import {SpinnerComponent} from "../../common/spinner/spinner.component";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {CommonModule} from "@angular/common";

@Component({
    selector: 'app-dash-block',
    templateUrl: './dash-block.component.html',
    imports: [
        CommonModule,
        SpinnerComponent,
        FaIconComponent
    ],
    styleUrls: ['./dash-block.component.css']
})
export class DashBlockComponent {
  @Input() title: string;
  @Input() data: any;
  @Input() error = false;
  @Input() headerTemplate: TemplateRef<any>;
  @Input() contentTemplate: TemplateRef<any>;
}
